var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import _ from 'lodash';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { Dropdown, DropdownContent, useDropdown } from 'ziphy-web-shared/basic/lib/functional';
import { $loader, $windowSize } from 'ziphy-web-shared/basic/utils';
import { apptMapActions } from '@config/appts';
import styles from './ApptButtons.module.scss';
const ApptButtons = ({ byRoute, className }) => {
    const { fullAppt, status, actions } = byRoute;
    const preparedList = useMemo(() => {
        let inPanel = [], inDropdown = [];
        let mapActions = apptMapActions({ fullAppt, status, actions });
        mapActions = _.orderBy(mapActions, ['visible'], ['desc']);
        mapActions.forEach((item) => {
            let hidden = false;
            if (item.visible < 0) {
                inDropdown.push(item);
                hidden = true;
            }
            else if (item.visible) {
                if (inPanel.length < ($windowSize.maxSM ? 0 : $windowSize.maxMD ? 1 : 2)) {
                    inPanel.push(item);
                }
                else {
                    inDropdown.push(item);
                    hidden = true;
                }
            }
            if (hidden) {
                inPanel.push(Object.assign(Object.assign({}, item), { hidden: true }));
            }
        });
        return { inPanel, inDropdown };
    }, [fullAppt, status, actions, $windowSize.maxMD, $windowSize.maxSM]);
    const handleAction = (item) => __awaiter(void 0, void 0, void 0, function* () {
        const fn = $loader.registerHandler('appt-handle-action-button-' + item.id, () => __awaiter(void 0, void 0, void 0, function* () {
            if (!_.isEmpty(item.actionProp)) {
                yield item.action(_.get(fullAppt, item.actionProp));
            }
            else {
                yield item.action();
            }
        }));
        yield fn();
    });
    const { filteredItems } = useDropdown(useMemo(() => preparedList.inDropdown.map((x) => (Object.assign(Object.assign({}, x), { onClick: x.action }))), [preparedList.inDropdown]));
    return (_jsxs("div", Object.assign({ className: classNames(styles.wrapper, className) }, { children: [preparedList.inPanel.map((item) => !item.hidden && (_jsx(Button, Object.assign({ mode: [item.primary ? 'primary' : 'secondary', 'sm'], onClick: () => handleAction(item), className: classNames(styles.button, item.marker && 'red_marker'), isLoading: $loader.isRunHandler('appt-handle-action-button-' + item.id), disabled: item.disabled }, { children: item.label }), item.id))), preparedList.inDropdown.length > 0 && (_jsx(Dropdown, Object.assign({ renderButton: ({ fieldRef, onToggle }) => (_jsx(Button, { ref: fieldRef, mode: ['secondary-icon', 'justIcon', 'sm'], onClick: onToggle, leftElement: 'moreDots' })), className: styles.dropdown, direction: ['bottom'] }, { children: _jsx(DropdownContent, { items: filteredItems }) })))] })));
};
export default observer(ApptButtons);
